module.exports = __webpack_public_path__ + "static/media/phoneBlack.de85c696.svg";